import { MessageSquareWarning } from 'lucide-react';

import { SidebarItem } from './SidebarItem';
import { SidebarSection } from './SidebarSection';

export function ObservabilitySidebar({
  isObservabilityEnabled,
}: {
  isObservabilityEnabled: boolean;
}) {
  return (
    <SidebarSection title="Additional Functionality">
      <SidebarItem
        label="Alerting"
        to={
          isObservabilityEnabled ? 'portainer.alerting' : 'portainer.settings'
        }
        params={
          !isObservabilityEnabled ? { section: 'additional-functionality' } : {}
        }
        icon={MessageSquareWarning}
        data-cy="portainerSidebar-alerting"
      />
    </SidebarSection>
  );
}
